import { render } from "./PolicyAgreementModal.vue?vue&type=template&id=3ef81780&scoped=true"
import script from "./PolicyAgreementModal.vue?vue&type=script&lang=js"
export * from "./PolicyAgreementModal.vue?vue&type=script&lang=js"

import "./PolicyAgreementModal.vue?vue&type=style&index=0&id=3ef81780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef81780"]])

export default __exports__